webpackJsonp([76474617998626],{

/***/ 2088:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"VisitHeaderDiagnosisSelection","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"patientDiagnosis","type":{"kind":"OBJECT","name":"PatientDiagnosis","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"patientDiagnosisId","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"visitHeaderConfigId","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-visit-header-diagnosis-selection-c62058fa6804967ad4e6.js